import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import FormPage from './FormPage';
import AlertBar from '../../../components/AlertBar/AlertBar';
import useMainForm from './useMainForm';
import FormShimmer from '../../../components/Shimmer/FormShimmer';

const MainForm = () => {

    const {
        mainFields,
        mainSections,
        mainFormState,
        mainFormErrors,
        handleMainFieldChange,
        isMounted,
        pageError,
        handleFormFileUpload
    } = useMainForm();

    return (
        <>
            <Grid container spacing={2}>
                {isMounted ?
                    <Grid md={12}>
                        <FormPage
                            sections={mainSections}
                            fields={mainFields}
                            formState={mainFormState}
                            formErrors={mainFormErrors}
                            handleFieldChange={handleMainFieldChange}
                            handleFileUploadChange={handleFormFileUpload}
                        />
                    </Grid>
                    :
                    <Grid md={12}>
                        <FormShimmer />
                    </Grid>
                }
            </Grid>

            {pageError.show &&
                <AlertBar
                    showAlert={pageError.show}
                    severity={"error"}
                    alertMessage={pageError.errorMessage}
                />
            }
        </>

    )

}

export default MainForm; 